import { render, staticRenderFns } from "./receiptGoodsTable.vue?vue&type=template&id=ab5641b8&scoped=true&"
import script from "./receiptGoodsTable.vue?vue&type=script&lang=js&"
export * from "./receiptGoodsTable.vue?vue&type=script&lang=js&"
import style0 from "./receiptGoodsTable.vue?vue&type=style&index=0&id=ab5641b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5641b8",
  null
  
)

export default component.exports